import React from 'react';

const Dashboard = () => (
  <div>
    <h2 className="text-2xl font-bold mb-2">MySpace Dashboard</h2>
    <p className="text-gray-700">Welcome to your dashboard. Add widgets, stats, or quick links here.</p>
  </div>
);

export default Dashboard;
